module.exports = __webpack_public_path__ + "img/eng_2.9255e9f0.jpg";